import { css } from 'styled-components';

import { maxWidth } from '@wecasa/web-ui/src/styles/mixins';

import { NAVIGATION_CONTAINER_BOTTOM_PADDING } from '../containers/navigation-container/navigation-container';

export const intercomGlobalStyle = css`
  /* Intercom collapses the host page to height:0 while its mobile messenger is open.
     Undone it so the app stays visible behind the resized messenger. The class is set by
     their JS on mobile viewports only, so no media query is needed. */
  :root.intercom-mobile-messenger-active > body {
    height: auto !important;
  }

  ${maxWidth.md`
    /* Lifted above the sticky MobileNavigation bar, only while it is mounted */
    body:has([data-mobile-navigation]) {
      .intercom-lightweight-app-launcher.intercom-launcher,
      .intercom-namespace .intercom-app > div[class*='intercom-with-namespace-'] {
        bottom: ${NAVIGATION_CONTAINER_BOTTOM_PADDING}px;
      }

      iframe[name='intercom-notification-stack-frame'] {
        bottom: ${NAVIGATION_CONTAINER_BOTTOM_PADDING}px !important;
      }
    }

    .intercom-messenger-frame {
      inset: auto 0 0 !important;
      width: 100% !important;
      height: calc(100% - 200px) !important;
      max-height: calc(100% - 200px) !important;
      border-radius: 16px 16px 0 0 !important;
    }
  `}
`;
